// extracted by mini-css-extract-plugin
module.exports = {"paragraphColor":"style_paragraphColor__bhpCG"};